import React, { Component } from 'react';
import { connect } from 'react-redux';

import SummaryShareFailedComponent from '../../../components/purchase-dashboard/group-summary/summary-share.failed';
import {
  showCommitModal,
  showWithdrawModal,
  SHARED_NAMESPACE,
} from '../../../actions';
import {
  getCurrentUserMembership,
  getCurrentPurchase,
  getNextPaymentProjected,
} from '../../../selectors/purchase-selector';

class SummaryShareFailed extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.onCommit.bind(this);
    this.onWithdraw = this.onWithdraw.bind(this);
  }

  onCommit() {
    this.props.showCommitModal();
  }

  onWithdraw() {
    this.props.showWithdrawModal();
  }

  render() {
    if (!this.props.membership) return null;

    return (
      <SummaryShareFailedComponent
        membership={this.props.membership}
        contributionAmount={this.props.contribution.amount}
        paymentDate={this.props.paymentDate}
        nextPayment={this.props.nextPayment}
        withdraw={this.props.withdraw}

        onCommit={this.onCommit}
        onWithdraw={this.onWithdraw}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const membership = getCurrentUserMembership(state);
  const failedContribution = membership && membership.currentContribution;

  return {
    membership,
    paymentDate: failedContribution.failedAt,
    costRange: purchase.costRange,
    contribution: failedContribution,
    nextPayment: getNextPaymentProjected(state, SHARED_NAMESPACE),
  };
};

const mapDispatchToProps = {
  showCommitModal,
  showWithdrawModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryShareFailed);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/summary-share-failed.container.js